import { Outlet, useLocation, useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
// import { useContext, useEffect } from "react";
// import { Context } from "../context/MainContext";
import CTA from "../components/CTA";

const MainLayout = () => {
  // const { user } = useContext(Context);
  // const navigate = useNavigate();
  const { pathname } = useLocation();

  // useEffect(() => {
  //   if (user?.roles === "admin") {
  //     navigate("/dashboard");
  //   }
  // }, [user, navigate]);

  return (
    <div className="mainLayout">
      <TopBar />
      <Outlet />
      {pathname !== "/" && <CTA />}
      <Footer />
    </div>
  );
};

export default MainLayout;
